const img = require('./ActiveProduct.svg'); export default img;